export const isAuthorized = () => {
  return !!localStorage.getItem("access_token");
};
